import Descriptions from './descriptions';
import DescriptionsItem from './descriptions-item';
var DefaultDesc = Descriptions;
DefaultDesc.Item = DescriptionsItem;
export default DefaultDesc;
//# sourceMappingURL=index.js.map